import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  useDisclosure,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  FormLabel,
  Input,
  Text,
  List,
  ListItem,
  IconButton,
  Grid,
  GridItem,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import Spinner from "common/components/spinner/Spinner";
import { postApi, getApi } from "common/services/api";
import { documentSchema } from "common/schema";
import FormDataUse, { commonUtils } from "./formDataUse";
import Upload from "common/modules/document/Upload";
import { toast } from "react-toastify";
import { CloseIcon } from "@chakra-ui/icons";
import { constant } from "common/constant";
import { MAX_FILE_SIZE } from "./calcUtils";
import { crmConstant } from "../constant";
import colors from "common/theme/foundations/colors";

const AddDocumentModal = ({
  setAddDocument,
  addDocument,
  linkId,
  from,
  setAction,
  fetchNewData,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [fileError, setFileError] = useState("");

  const user = JSON.parse(localStorage.getItem("user"));

  const fetchData = async (isLoading = true) => {
    setIsLoading(isLoading);
    let result = await getApi(
      user.role === "superAdmin"
        ? "api/document"
        : `api/document?createBy=${user._id}`
    );
    setData(result?.data);
    setIsLoading(false);
  };
  useEffect(() => {
    fetchData();
  }, [addDocument]);

  const initialValues = {
    files: "",
    filename: "",
    linkLead: from === crmConstant.leadComponentName && linkId,
    linkContact: from === crmConstant.contactComponentName && linkId,
    linkAccount: from === crmConstant.accounts && linkId,
    linkDeal: from === crmConstant.deals && linkId,
    createBy: user._id,
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: documentSchema,
    onSubmit: (values, { resetForm }) => {
      addData();
    },
  });
  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    resetForm,
  } = formik;

  const addData = async (isLoading = true) => {
    try {
      setIsLoading(isLoading);
      const payload = commonUtils.formData(values);

      const endpointMap = {
        lead: "api/document/addDocumentLead",
        contact: "api/document/addDocumentContact",
        accounts: "api/document/addDocumentAccount",
        deals: "api/document/addDocumentDeal",
      };

      const endpoint =
        endpointMap[from.toLowerCase()] || `api/document/addDocument${from}`;

      const response = await postApi(endpoint, payload);

      if (response && response.status === 200) {
        fetchData(false);
        formik.resetForm();
        // setAction((pre) => !pre);

        if (fetchNewData) {
          if (from === crmConstant.accounts || from === crmConstant.deals) {
            fetchNewData(null, false);
          } else {
            fetchNewData(false);
          }
        }

        setAddDocument(false);
        toast.success("Document added successfully");
      }
    } catch (e) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const handleFileSelect = (file) => {
    if (file[0].size > MAX_FILE_SIZE) {
      setFileError(crmConstant.maxFileSize);
      return;
    }
    setFileError("");
    setFieldValue("files", file);
  };

  return (
    <Modal
      onClose={() => {
        setAddDocument(false);
        resetForm();
      }}
      isOpen={addDocument}
      isCentered
    >
      <ModalOverlay />
      <ModalContent maxWidth={"700px"}>
        <ModalHeader>{constant.uploadFiles}</ModalHeader>
        <IconButton
          size="xs"
          className="closeIcon"
          onClick={() => setAddDocument(false)}
          icon={<CloseIcon />}
        />

        <ModalBody className="modalBody">
          <Grid templateColumns="repeat(2, 1fr)" mb={3} gap={4}>
            {/* <GridItem colSpan={1}>
              <Box>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  mb="8px"
                >
                  {constant.folderName}
                  <Text color={"red"}>*</Text>
                </FormLabel>
                <Input
                  //   onFocus={onOpen}
                  fontSize="sm"
                  onChange={handleChange}
                  //   onBlur={() => setTimeout(onClose, 200)}
                  value={values.folderName}
                  name="folderName"
                  placeholder="Enter Folder Name"
                  fontWeight="500"
                  borderColor={
                    errors?.folderName && touched?.folderName ? "red.300" : null
                  }
                />
                {addDocument &&
                  values?.folderName &&
                  data?.filter((option) =>
                    option?.folderName
                      ?.toLowerCase()
                      ?.includes(values?.folderName.toLowerCase())
                  ).length > 0 && (
                    <List
                      position={"relative"}
                      border={"1px solid"}
                      bg={"gray.100"}
                      width={"100%"}
                      borderRadius={"0px 0px 20px 20px"}
                      lineHeight={1}
                    >
                      {data
                        ?.filter((option) =>
                          option?.folderName
                            ?.toLowerCase()
                            ?.includes(values?.folderName.toLowerCase())
                        )
                        .map((option, index) => (
                          <ListItem
                            p={3}
                            borderBottom={"2px solid #efefef"}
                            sx={{ "&:last-child": { borderBottom: "none" } }}
                            key={option?._id}
                            cursor={"pointer"}
                            onClick={() => {
                              setFieldValue("folderName", option?.folderName);
                            }}
                          >
                            {option?.folderName}
                          </ListItem>
                        ))}
                    </List>
                  )}
                <Text mb="10px" color={colors.red}>
                  {" "}
                  {errors.folderName && touched.folderName && errors.folderName}
                </Text>
              </Box>
            </GridItem> */}
            <GridItem colSpan={1}>
              <Box>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  mb="8px"
                >
                  {constant.fileName}
                  <Text color={colors.red[500]}>*</Text>
                </FormLabel>
                <Input
                  fontSize="sm"
                  onChange={handleChange}
                  //   onBlur={() => setTimeout(onClose, 200)}
                  value={values.filename}
                  name="filename"
                  placeholder="Enter File Name"
                  fontWeight="500"
                  borderColor={
                    errors?.filename && touched?.filename ? "red.300" : null
                  }
                />
                <Text mb="10px" color={"red"}>
                  {" "}
                  {errors.filename && touched.filename && errors.filename}
                </Text>
              </Box>
            </GridItem>
          </Grid>
          <Upload
            count={values?.files?.length > 0 ? values.files.length : 0}
            onFileSelect={handleFileSelect}
          />
          {fileError && <Text color="red">{fileError}</Text>}
        </ModalBody>
        <ModalFooter>
          <Button
            className="theme-btn2 cancelBtn"
            size="sm"
            variant="outline"
            colorScheme="red"
            onClick={() => {
              setAddDocument(false);
              resetForm();
            }}
          >
            Close
          </Button>

          <Button
            className="theme-btn1"
            size="sm"
            variant="brand"
            ml={4}
            onClick={handleSubmit}
            disabled={
              isLoading ||
              !values.filename.trim() ||
              !values.files ||
              values.files.length === 0 ||
              !!fileError
            }
          >
            {isLoading ? <Spinner /> : "Save"}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddDocumentModal;
